import * as React from 'react';
import history from "../history";
import {ConnectedRouter} from "react-router-redux";
import {Route, Switch} from "react-router-dom";
import ModuleListController from "../containers/ModuleListController";
import {ROUTE_MODULES, ROUTE_MODULES_CREATE, ROUTE_MODULES_DETAIL} from "./index";
import ModuleCreateController from "../containers/ModuleCreateController";

export default () => (
	<ConnectedRouter history={history}>
		<Switch>
			<Route exact path={ROUTE_MODULES} component={ModuleListController}/>
			<Route path={ROUTE_MODULES_CREATE} component={ModuleCreateController}/>
			<Route path={ROUTE_MODULES_DETAIL} component={() => <div>Module detail</div>}/>
		</Switch>
	</ConnectedRouter>
);


// WEBPACK FOOTER //
// ./src/routes/ModuleRoutes.js